




























import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

@Component({
})
export default class FileInput extends Vue {
  @Prop(String) value: '';
  @Prop(Boolean) preventUploadCall: false;

  uploadError: Error | null = null;
  fileUploaded: string = '';

  $refs: {
    fileInput: HTMLInputElement
  }

  /* Emits the file to parent when handled by this.updateUserAvatar */
  @Emit('upload-file')
  emitFile (val: string | File) {
    return val;
  }

  /* Ensuring focus of input when clicking in it */
  focusFileInput () {
    this.$refs.fileInput.click();
  }

  /*
    Is triggered when a file is uplodaded. This method will create files from
    uploaded sources
  */
  onFileChange (source: any) {
    const files: Array<File> = Array.from(source.files);
    if (source.value) source.value = null; // cleanup input after usage
    if (!files.length) return;
    this.updateUserAvatar(files[0]);
  }

  /*
    This method calls a store function to upload the file to the server.
    The server will return an URL string
  */
  async updateUserAvatar (file: File) {
    this.uploadError = null;
    if (this.preventUploadCall) return this.emitFile(file);
    try {
      this.fileUploaded = await this.$store.dispatch('uploadFile', file);
      this.emitFile(this.fileUploaded);
    } catch (error) {
      this.uploadError = error;
    }
  }
};
